"use client";

import { c as _c } from "react/compiler-runtime";
import { useNumberFormatter } from "@opensea/i18n";
import { Media, Separator, SideSheetBody, SideSheetHeader, SideSheetHeaderTitle, UnstyledButton, useToasts } from "@opensea/ui-kit";
import { Close, ExpandMore } from "@opensea/ui-kit/icons";
import { useTranslations } from "use-intl";
import { useSnapshot } from "valtio";
import { Button } from "../../../components/Button";
import { useAddress } from "../../../polychain/hooks";
import { FlowCallbackActions } from "../../../stores/flowCallbackStore";
import { FlowActions, FlowState } from "../../../stores/flowStore";
import { SwapConfiguration } from "./components/SwapConfiguration";
import { SwapModule } from "./components/SwapModule";
import { useSwapContext } from "./provider/SwapContext";
import { SwapProvider } from "./provider/SwapProvider";
import { getSwapReceiptFailReasonMessage } from "./utils";
export const SwapFlow = t0 => {
  const $ = _c(27);
  const {
    onBack,
    onClose,
    initialFromCurrency,
    initialToCurrency
  } = t0;
  const t = useTranslations("wallet.SwapFlow");
  let t1;
  if ($[0] !== onBack || $[1] !== t) {
    t1 = onBack && <UnstyledButton onClick={onBack}><ExpandMore className="rotate-90" size={24} title={t("back")} /></UnstyledButton>;
    $[0] = onBack;
    $[1] = t;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  let t2;
  if ($[3] !== t) {
    t2 = t("swap");
    $[3] = t;
    $[4] = t2;
  } else {
    t2 = $[4];
  }
  let t3;
  if ($[5] !== t2) {
    t3 = <SideSheetHeaderTitle>{t2}</SideSheetHeaderTitle>;
    $[5] = t2;
    $[6] = t3;
  } else {
    t3 = $[6];
  }
  let t4;
  if ($[7] === Symbol.for("react.memo_cache_sentinel")) {
    t4 = <SwapConfiguration className="ml-auto" />;
    $[7] = t4;
  } else {
    t4 = $[7];
  }
  let t5;
  if ($[8] !== onClose) {
    t5 = () => {
      onClose();
    };
    $[8] = onClose;
    $[9] = t5;
  } else {
    t5 = $[9];
  }
  let t6;
  if ($[10] !== t) {
    t6 = t("close");
    $[10] = t;
    $[11] = t6;
  } else {
    t6 = $[11];
  }
  let t7;
  if ($[12] !== t6) {
    t7 = <Close size={20} title={t6} />;
    $[12] = t6;
    $[13] = t7;
  } else {
    t7 = $[13];
  }
  let t8;
  if ($[14] !== t5 || $[15] !== t7) {
    t8 = <Media lessThan="md"><Button className="h-8 p-1.5" onClick={t5} variant="ghost">{t7}</Button></Media>;
    $[14] = t5;
    $[15] = t7;
    $[16] = t8;
  } else {
    t8 = $[16];
  }
  let t9;
  if ($[17] !== t1 || $[18] !== t3 || $[19] !== t8) {
    t9 = <SideSheetHeader className="gap-2">{t1}{t3}{t4}{t8}</SideSheetHeader>;
    $[17] = t1;
    $[18] = t3;
    $[19] = t8;
    $[20] = t9;
  } else {
    t9 = $[20];
  }
  let t10;
  let t11;
  if ($[21] === Symbol.for("react.memo_cache_sentinel")) {
    t10 = <Separator />;
    t11 = <SwapFlowBase />;
    $[21] = t10;
    $[22] = t11;
  } else {
    t10 = $[21];
    t11 = $[22];
  }
  let t12;
  if ($[23] !== initialFromCurrency || $[24] !== initialToCurrency || $[25] !== t9) {
    t12 = <SwapProvider initialFromCurrency={initialFromCurrency} initialToCurrency={initialToCurrency} source="wallet-sidesheet">{t9}{t10}{t11}</SwapProvider>;
    $[23] = initialFromCurrency;
    $[24] = initialToCurrency;
    $[25] = t9;
    $[26] = t12;
  } else {
    t12 = $[26];
  }
  return t12;
};
const SwapFlowBase = () => {
  const $ = _c(13);
  const t = useTranslations("wallet.SwapFlow");
  const {
    setContainer
  } = useSwapContext();
  const address = useAddress();
  const {
    flow
  } = useSnapshot(FlowState);
  const buttonColor = flow?.buttonColor;
  const {
    showSuccessMessage,
    showErrorMessage
  } = useToasts();
  const numberFormatter = useNumberFormatter();
  let t0;
  if ($[0] !== address || $[1] !== flow || $[2] !== numberFormatter || $[3] !== showErrorMessage || $[4] !== showSuccessMessage || $[5] !== t) {
    t0 = receipt => {
      if (receipt.status === "SUCCESS") {
        showSuccessMessage(t("successMessage", {
          quantity: numberFormatter(receipt.toQuantity),
          symbol: receipt.toAsset.symbol
        }), {
          duration: 3000
        });
        FlowActions.startFlow({
          type: "view-wallet",
          address: address ?? "",
          tab: "crypto"
        });
      } else {
        if (receipt.status === "FAILED") {
          FlowCallbackActions.failAll(flow, receipt);
          showErrorMessage(t("failureMessage", {
            status: receipt.crossChainRefunded ? t("refunded") : t("failed"),
            reason: getSwapReceiptFailReasonMessage(receipt.failReason ?? "UNKNOWN")
          }), {
            duration: 3000
          });
        }
      }
    };
    $[0] = address;
    $[1] = flow;
    $[2] = numberFormatter;
    $[3] = showErrorMessage;
    $[4] = showSuccessMessage;
    $[5] = t;
    $[6] = t0;
  } else {
    t0 = $[6];
  }
  const onCompleted = t0;
  let t1;
  if ($[7] !== buttonColor || $[8] !== onCompleted) {
    t1 = <SwapModule buttonColor={buttonColor} onCompleted={onCompleted} surface="sheet" />;
    $[7] = buttonColor;
    $[8] = onCompleted;
    $[9] = t1;
  } else {
    t1 = $[9];
  }
  let t2;
  if ($[10] !== setContainer || $[11] !== t1) {
    t2 = <SideSheetBody className="flex grow flex-col p-4 lg:px-4" ref={setContainer}>{t1}</SideSheetBody>;
    $[10] = setContainer;
    $[11] = t1;
    $[12] = t2;
  } else {
    t2 = $[12];
  }
  return t2;
};